import { getToday } from '.';
import moment from 'moment-timezone';

export const ONE_MINUTE_TO_MILLISECONDS = 60 * 1000;
export const ONE_HOUR_TO_MILLISECONDS = 60 * ONE_MINUTE_TO_MILLISECONDS;
export const ONE_DAY_TO_MILLISECONDS = 24 * ONE_HOUR_TO_MILLISECONDS;
export const ONE_YEAR_TO_MILLISECONDS = 365 * ONE_DAY_TO_MILLISECONDS;

export enum EN_WEEKDAY_KR {
  '월' = 1,
  '화',
  '수',
  '목',
  '금',
  '토',
  '일',
}

const dayNames = {
  Today: '오늘',
  Sun: '일',
  Mon: '월',
  Tue: '화',
  Wed: '수',
  Thu: '목',
  Fri: '금',
  Sat: '토',
};

const isToday = (date: moment.Moment): boolean => date.format('YYYYMMDD') === getToday().format('YYYYMMDD');

export const getDiffDays = (checkinDate: moment.Moment, checkoutDate: moment.Moment): number => {
  return checkoutDate.diff(checkinDate, 'days');
};

export const displayDiffDays = (
  checkinDate: moment.Moment = getToday(),
  checkoutDate: moment.Moment = checkinDate,
): string => {
  return `${checkoutDate.diff(checkinDate, 'days')}박`;
};

/**
 * 체크인, 체크아웃 날짜를 기반으로 출력할 문자열을 반환합니다.
 * @param checkinDate - 체크인 날짜
 * @param checkoutDate - 체크아웃 날짜
 * @param format - 출력포맷
 * @param option.noDiff - 몇박인지 출력 여부
 * @param option.delimeter - 체크인-아웃 사이 구분자
 * @param option.diffDelimiter - 체크인-아웃과 몇박 사이 구분자
 */
export const displayDates = (
  checkinDate: moment.Moment = getToday(),
  checkoutDate: moment.Moment = checkinDate,
  format: string = 'M월 D일',
  option?: { noDiff?: boolean; delimiter?: string; diffDelimiter?: string },
): string => {
  const todayName = checkinDate.format('ddd');
  const noDiff = option?.noDiff ?? false;
  const delimiter = option?.delimiter ?? ' ~ ';
  const diffDelimiter = option?.diffDelimiter ?? ', ';

  if (checkinDate.isSame(checkoutDate)) {
    return `${checkinDate.format(format)}(${isToday(checkinDate) ? dayNames.Today : todayName})`;
  }

  return (
    `${checkinDate.format(format)}${delimiter}${checkoutDate.format(format)}` +
    (noDiff ? '' : `${diffDelimiter}${displayDiffDays(checkinDate, checkoutDate)}`)
  );
};
